import { createReducer, on } from '@ngrx/store';
import { EnvironmentSlice } from '../app-state';
import { initialEnvironmentSlice } from '../initial-slices';
import * as EnvironmentActions from './environment.actions';

export const environmentReducer = createReducer(
  initialEnvironmentSlice,
  on(EnvironmentActions.setJiraUiBaseUrl, (state, action): EnvironmentSlice => {
    let isJiraCloud = false;
    try {
      isJiraCloud = new URL(action.jiraUiBaseUrl).hostname.includes('atlassian');
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_) {
      // invalid URL, ignore -- default is false
    }
    return { ...state, jiraUiBaseUrl: action.jiraUiBaseUrl, isJiraCloud: isJiraCloud };
  }),
  on(EnvironmentActions.setDataFromIFrameMessage, (state, action): EnvironmentSlice => ({
    ...state,
    ...action.environmentData,
  })),
  on(EnvironmentActions.setEnvironmentData, (state, action): EnvironmentSlice => ({
    ...state,
    ...action.environmentData,
  })),
  on(EnvironmentActions.setEnvironmentDataForRelease, (state, action): EnvironmentSlice => {
    // We do not want to use the delivery guid provided in the local environment.ts, but always use the one from the URL parameter
    // see RoutingEffects.onSetPipelineReleaseViewRouteParametersSetDeliveryGuid
    return {
      ...state,
      ...action.environmentData,
      deliveryGuid: state.deliveryGuid,
    };
  }),
  on(EnvironmentActions.setDeliveryGuid, (state, action): EnvironmentSlice => ({
    ...state,
    deliveryGuid: action.deliveryGuid,
  })),
);
